export interface LayoutData {
	blankLayout?: boolean;
	showEdit?: boolean;
	roles?: string[];
}
